import type { WeldJoint } from './SpoolsProduction';

/** Matches the workflow strip steps in `SpoolDetailModal`. */
export type SpoolModalWorkflowStep =
  | 'fitup'
  | 'preheat'
  | 'welding'
  | 'repair_weld'
  | 'vt'
  | 'ndt'
  | 'coating'
  | 'accept';

/**
 * When the backend flags a repair / retest cycle, this selects which tab should open.
 * Linear progression (fit-up → … → accept) is overridden until the cycle completes.
 */
export function workflowRepairOverridesStep(weld: WeldJoint | null): SpoolModalWorkflowStep | null {
  const wr = weld?.workflowRepair;
  if (!wr?.phase) return null;
  switch (wr.phase) {
    case 'awaiting_repair_weld':
      return wr.sourceStep === 'ndt' ? 'repair_weld' : 'welding';
    case 'awaiting_vt_retest':
      return 'vt';
    case 'awaiting_ndt_retest':
      return 'ndt';
    default:
      return null;
  }
}

/** Highlights the Weld / VT / NDT pill when that step is the active repair stage. */
export function workflowStepShowsRepairCue(weld: WeldJoint | null, stepId: SpoolModalWorkflowStep): boolean {
  const wr = weld?.workflowRepair;
  if (!wr?.phase) return false;
  if (wr.phase === 'awaiting_repair_weld' && (stepId === 'welding' || stepId === 'repair_weld')) return true;
  if (wr.phase === 'awaiting_vt_retest' && stepId === 'vt') return true;
  if (wr.phase === 'awaiting_ndt_retest' && stepId === 'ndt') return true;
  return false;
}
